const translations = {
    button: 'Add Aircraft'
};

export default translations;
